import { lineAmountWithOvertime, canApplyHiredEquipmentOvertime, splitHiredEquipmentOvertimeHours } from './overtime';

/** Hours that pick up fuel $/hr: straight-time when OT applies, otherwise the full qty. */
export function fuelHoursForLine(
  qty: number | null,
  overtimeEligible?: boolean | null,
  unit?: string | null,
): number {
  if (qty == null || Number.isNaN(qty) || qty <= 0) return 0;
  if (canApplyHiredEquipmentOvertime(overtimeEligible, unit)) {
    return splitHiredEquipmentOvertimeHours(qty).straight;
  }
  return qty;
}

/** qty × rate, or OT-split hours when overtimeEligible and unit is Hours, plus fuel on regular hours. */
export function lineAmount(
  qty: number | null,
  rate: number | null,
  overtimeEligible?: boolean | null,
  unit?: string | null,
  fuelPerHour = 0,
): number {
  const base = lineAmountWithOvertime(qty, rate, overtimeEligible, unit);
  // V2-004: no rate, no amount – fuel is never charged on a line that has no rate yet.
  if (rate == null || !(rate > 0) || !(fuelPerHour > 0)) return base;
  return base + fuelHoursForLine(qty, overtimeEligible, unit) * fuelPerHour;
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function sumAmounts(
  rows: Array<{
    qty: number | null;
    rate: number | null;
    overtimeEligible?: boolean | null;
    unit?: string | null;
    fuelPerHour?: number | null;
  }>,
): number {
  return rows.reduce(
    (sum, row) =>
      sum + lineAmount(row.qty, row.rate, row.overtimeEligible, row.unit, row.fuelPerHour ?? 0),
    0,
  );
}
